import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {DashboardCard} from './DashboardCard';


class _CSRCard extends React.Component<Tgcc.BaseProps, any> {

    state = {impersonate: false, showCreate: false, email: '', division: 'Corporate', creating: false, error: '', createdId: '',
        firstName: '', lastName: '', school: '', organization: '', address: '', city: '', St: '', zip: '', phone: '', smsAllowed: true, group: '', buyer: 'No', studentGroup: '', marketingOptIn: true };

    componentDidMount() {
        const path = window.location.pathname.toLowerCase();
    
        if (path.startsWith('/campus')) {
            localStorage.setItem('division', 'campus');
        } else if (path.startsWith('/indigo')) {
            localStorage.setItem('division', 'indigo');
        } else {
            // default to corporate if it's just /dashboard or unknown
            localStorage.setItem('division', 'corporate');
        }
    }
    

    openCSR = () => {browserHistory.push(Tgcc.Routes.CSR)}
    openDesignSearch = () =>{browserHistory.push(Tgcc.Routes.DesignSearch)};

    doImpersonate = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.Impersonate}});
    }
    openCreateCustomer = () => { this.setState({ showCreate: true, error: '', email: '', division: 'Corporate' }); }
    closeCreateCustomer = () => { this.setState({ showCreate: false, creating: false, error: '', createdId: '' }); }
    createCustomer = () => {
        const email = (this.state.email || '').trim();
        if (!email) { this.setState({ error: 'Email required' }); return; }
        this.setState({ creating: true, error: '' });
        const profile = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            schoolOrBusiness: this.state.school,
            organization: this.state.organization,
            address: this.state.address,
            city: this.state.city,
            state: this.state.St,
            zip: this.state.zip,
            phone: this.state.phone,
            smsAllowed: this.state.smsAllowed,
            group: this.state.group,
            buyer: this.state.buyer,
            studentGroup: this.state.studentGroup,
            marketingOptIn: this.state.marketingOptIn
        };
        const csrEmail = (this.props.state && this.props.state.UserInfo && this.props.state.UserInfo.email) ? this.props.state.UserInfo.email : '';
        Request.createManagedCustomer(
            email,
            (this.state.division as any) || 'Corporate',
            profile,
            csrEmail,
            (res: any) => {
                this.setState({ creating: false, showCreate: false, createdId: res.id });
                // Automatically impersonate the created customer
                this.impersonateAndRedirect(email, this.state.division);
            },
            (err: string) => this.setState({ creating: false, error: err })
        );
    }

    impersonateAndRedirect = (customerEmail: string, division: string) => {
        // Use the existing canImpersonate flow to start impersonation
        Request.canImpersonate(
            this.props.state.LoginData.token,
            customerEmail,
            () => {
                // Create impersonated login data
                const impersonatedLoginData = Object.assign({}, this.props.state.LoginData, { impersonate: customerEmail });
                // Use successfulLogin to update the state and redirect
                Tgcc.successfulLogin(this.props.dispatch, impersonatedLoginData, true);
                // Redirect to appropriate proof edit page based on division
                this.redirectToProofEdit(division);
            },
            (err: string) => {
                this.setState({ error: `Failed to impersonate customer: ${err}` });
            }
        );
    }

    redirectToProofEdit = (division: string) => {
        // Small delay to ensure state is updated before redirect
        setTimeout(() => {
            switch (division.toLowerCase()) {
                case 'collegiate':
                case 'campus':
                    browserHistory.push(Tgcc.Routes.CampusProofEdit);
                    break;
                case 'indigo':
                    browserHistory.push(Tgcc.Routes.IndigoProofEdit);
                    break;
                case 'corporate':
                default:
                    browserHistory.push(Tgcc.Routes.ProofEdit);
                    break;
            }
        }, 100);
    }
    openChange = () =>{browserHistory.push(Tgcc.Routes.ChangeByCsr)}
    openCatalog = () => {browserHistory.push(Tgcc.Routes.Catalog )};
    openWebstore = () => {browserHistory.push(Tgcc.Routes.Webstore )};
    openDtdSamplePrint = () => {browserHistory.push(Tgcc.Routes.DtdSamplePrint)};
    render() {
        return (
            <DashboardCard title="For CSR's" height="unset">
                <div style={Tgcc.Styles.grayButton} onClick={this.doImpersonate}>Impersonate a customer</div>
                <div style={Tgcc.Styles.grayButton} onClick={this.openCreateCustomer}>Create a Customer</div>
                <div style={Tgcc.Styles.grayButton} onClick={this.openCSR}>Generate Customer Links</div>
                <div style={Tgcc.Styles.grayButton} onClick={this.openDesignSearch}>Search All Designs</div>
                <div style={Tgcc.Styles.grayButton} onClick={this.openChange}> Submit Change</div>
                <div style={Tgcc.Styles.grayButton} onClick={this.openCatalog}>Submit Marketing Request</div>
                <div style={Tgcc.Styles.grayButton} onClick={this.openWebstore}>Submit Webstore</div>
                <div style={Tgcc.Styles.grayButton} onClick={this.openDtdSamplePrint}>Request a DTD Sample Print</div>
                {this.state.showCreate && (
                    <div key="createCustomerOverlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                        <div key="createCustomerDialog" style={{ background: '#fff', padding: '24px', borderRadius: '12px', width: '90%', maxWidth: '520px', boxShadow: '0 16px 40px rgba(0,0,0,0.2)', position: 'relative' }}>
                            <div key="closeX" onClick={this.closeCreateCustomer} style={{ position: 'absolute', right: 12, top: 10, cursor: 'pointer', fontSize: '20px', color: '#888' }}>×</div>
                            <h3 style={{ margin: '0 0 8px 0', fontFamily: 'Lulo', letterSpacing: '0.1em' }}>Create a Customer</h3>
                            <div style={{ color: '#555', marginBottom: '16px', lineHeight: '20px' }}>Enter the customer's email and division. We'll send them a setup link and you can start acting on their behalf immediately.</div>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                <input type="email" placeholder="customer@example.com" value={this.state.email} onChange={(e) => this.setState({ email: (e.currentTarget && e.currentTarget.value) ? e.currentTarget.value : '' })} style={{ border: '1px solid #ccc', height: '40px', flex: 1, padding: '0 10px', borderRadius: '6px' }} />
                                <select value={this.state.division} onChange={(e) => this.setState({ division: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '40px', padding: '0 10px', borderRadius: '6px' }}>
                                    <option value="Collegiate">Collegiate</option>
                                    <option value="Corporate">Corporate</option>
                                    <option value="Indigo">Indigo</option>
                                </select>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                                <input type="text" placeholder="First name" value={this.state.firstName} onChange={(e) => this.setState({ firstName: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <input type="text" placeholder="Last name" value={this.state.lastName} onChange={(e) => this.setState({ lastName: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <input type="text" placeholder="School/Business" value={this.state.school} onChange={(e) => this.setState({ school: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <input type="text" placeholder="Organization" value={this.state.organization} onChange={(e) => this.setState({ organization: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <input type="text" placeholder="Address" value={this.state.address} onChange={(e) => this.setState({ address: e.currentTarget.value })} style={{ gridColumn: '1 / span 2', border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <input type="text" placeholder="City" value={this.state.city} onChange={(e) => this.setState({ city: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <input type="text" placeholder="State" value={this.state.St} onChange={(e) => this.setState({ St: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <input type="text" placeholder="Zip" value={this.state.zip} onChange={(e) => this.setState({ zip: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <input type="text" placeholder="Phone" value={this.state.phone} onChange={(e) => this.setState({ phone: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input type="checkbox" checked={this.state.smsAllowed} onChange={(e) => this.setState({ smsAllowed: e.currentTarget.checked })} />
                                    Receive Text Notifications
                                </label>
                                <input type="text" placeholder="Student Group" value={this.state.studentGroup} onChange={(e) => this.setState({ studentGroup: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <input type="text" placeholder="Group Size" value={this.state.group} onChange={(e) => this.setState({ group: e.currentTarget.value })} style={{ border: '1px solid #ccc', height: '36px', padding: '0 10px', borderRadius: '6px' }} />
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input type="checkbox" checked={this.state.buyer === 'Yes'} onChange={(e) => this.setState({ buyer: e.currentTarget.checked ? 'Yes' : 'No' })} />
                                    Are they the buyer?
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input type="checkbox" checked={this.state.marketingOptIn} onChange={(e) => this.setState({ marketingOptIn: e.currentTarget.checked })} />
                                    Marketing Opt‑In
                                </label>
                            </div>
                            {this.state.error && <div style={{ color: 'red', marginBottom: '8px', fontWeight: 700 }}>{this.state.error}</div>}
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <div style={{ ...Tgcc.Styles.grayButton, backgroundColor: '#777', color: '#fff' }} onClick={this.closeCreateCustomer}>Cancel</div>
                                <div style={{ ...Tgcc.Styles.grayButton, backgroundColor: '#3366cc', color: '#fff', opacity: this.state.creating ? 0.7 : 1, pointerEvents: this.state.creating ? 'none' as any : 'auto' }} onClick={this.createCustomer}>{this.state.creating ? 'Creating…' : 'Create'}</div>
                            </div>
                        </div>
                    </div>
                )}
            </DashboardCard>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { state: state};
};

export var CSRCard = connect(mapStateToProps)(_CSRCard);